export default "__VITE_ASSET__0fea6b96__"